$(document).ready(function(){
    $(".hamburger button, .sidenav-overlay").click(function(){
        $(".hamburger button").find(".fa").toggleClass("fa-bars fa-times");
        $("body").toggleClass("expand-sidenav");
    });
    $(".top-header .dropdown-toggle").click(function(){        
        $(this).parent().toggleClass("show-dropdown");
    });
    $(".top-header .overlay").click(function(){        
        $(this).parent().removeClass("show-dropdown");
    });
    $(".has-child > a").click(function(){         
        $(".sidenav-link li").removeClass("active");
        $(this).parent().addClass("active");
    });
    $(".has-child .back").click(function(){                
        $(".sidenav-link li").removeClass("active");
    });
    $(".search-area .btn").click(function(){                
        $(".search-area").toggleClass("active");
    });
    
    $('[data-toggle="tooltip"]').tooltip()   
    
});

$(document).ready( function () {
  if (window.navigator.userAgent === 'AndroidWebView') {
    var str = Android.deviceInfo("toast");
    localStorage.setItem("deviceID", str);
  }
});
